import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import preferences from './preferences.reducers';
import settings from './settings.reducers';
import users from './users.reducers';
import miscellaneous from './miscellaneous.reducers';
import products from "./products.reducers";
import changeLog from "./change-log.reducers";
import bookmark from './bookmark.reducers';
import banner from './banner.reducers';
import staticPages from './staticPages.reducers';
import categories from "./categories.reducers";
import coupons from "./coupons.reducers";
import flags from "./flags.reducers";
import listActions from "./listActions.reducers";
import instagram from "./instagram.reducers";
import forms from "./forms.reducers";
import changesHistory from './changesHistory.reducers';
import configurations from './configuration.reducers';
import eventLogs from './eventLogs.reducers';
import recommendation from "./recommendation.reducers";
import specialOffers from "./specialOffers.reducers";
import listingRecommendation from "./listingRecommendation.reducers";

const reducers = {
  routing: routerReducer,
  preferences,
  settings,
  products,
  users,
  miscellaneous,
  changeLog,
  bookmark,
  banner,
  staticPages,
  categories,
  coupons,
  flags,
  listActions,
  instagram,
  forms,
  changesHistory,
  configurations,
  recommendation,
  listingRecommendation,
  eventLogs,
  specialOffers,

};

module.exports = combineReducers(reducers);



// WEBPACK FOOTER //
// ./reducers/index.js